import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#262626",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 8.49999C8.50024 7.22868 9.45454 6.16 10.7177 6.01646C11.9809 5.87291 13.1507 6.70022 13.4361 7.93906C13.7216 9.1779 13.0319 10.4337 11.8333 10.8575C11.3337 11.0341 10.9997 11.5067 11 12.0367V12.875",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 15.375C10.8274 15.375 10.6875 15.5149 10.6875 15.6875C10.6875 15.8601 10.8274 16 11 16C11.1726 16 11.3125 15.8601 11.3125 15.6875C11.3125 15.5149 11.1726 15.375 11 15.375V15.375",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11 20.375C16.1777 20.375 20.375 16.1777 20.375 11C20.375 5.82233 16.1777 1.625 11 1.625C5.82233 1.625 1.625 5.82233 1.625 11C1.625 16.1777 5.82233 20.375 11 20.375Z",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20stroke%3D%22%23262626%22%3E%3Cpath%20d%3D%22M8.5%208.49999C8.50024%207.22868%209.45454%206.16%2010.7177%206.01646C11.9809%205.87291%2013.1507%206.70022%2013.4361%207.93906C13.7216%209.1779%2013.0319%2010.4337%2011.8333%2010.8575C11.3337%2011.0341%2010.9997%2011.5067%2011%2012.0367V12.875%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11%2015.375C10.8274%2015.375%2010.6875%2015.5149%2010.6875%2015.6875C10.6875%2015.8601%2010.8274%2016%2011%2016C11.1726%2016%2011.3125%2015.8601%2011.3125%2015.6875C11.3125%2015.5149%2011.1726%2015.375%2011%2015.375V15.375%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M11%2020.375C16.1777%2020.375%2020.375%2016.1777%2020.375%2011C20.375%205.82233%2016.1777%201.625%2011%201.625C5.82233%201.625%201.625%205.82233%201.625%2011C1.625%2016.1777%205.82233%2020.375%2011%2020.375Z%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E%0A";
